/**
 * Generate a share link with tracking token
 * @param {string} contentType - 'set' or 'track'
 * @param {number} contentId - ID of the set or track
 * @param {object} api - API client instance
 * @returns {Promise<string|null>} Share URL with ref parameter, or null if generation fails
 */
export default async function generateShareLink(contentType, contentId, api) {
  try {
    const response = await api.post('/shares', {
      content_type: contentType, // 'set' or 'track'
      content_id: contentId,
    });

    if (response.ok) {
      return response.body.share_url; // URL with ref parameter
    }
    return null;
  } catch (error) {
    console.error('Failed to generate share link:', error);
    return null;
  }
}
